import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Anime%20style%20epic%20cinematic%20scene%20with%20warm%20sunset%20lighting%2C%20colorful%20clouds%2C%20vibrant%20Japanese%20anime%20art%20style%2C%20dreamy%20atmosphere%2C%20soft%20golden%20hour%20glow%2C%20artistic%20illustration%20with%20warm%20orange%20coral%20and%20peach%20tones%2C%20beautiful%20scenic%20composition&width=1600&height=900&seq=hero-bg-main&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6 py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
          <i className="ri-verified-badge-line text-primary-300 text-sm"></i>
          <span className="text-xs text-white/90 font-medium">官方正版入口 · 安全可靠</span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
          {heroData.title}
        </h1>

        <p className="text-lg md:text-xl text-primary-300 font-heading mb-4">
          {heroData.subtitle}
        </p>

        <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto mb-8 leading-relaxed">
          {heroData.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/recommended"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            <i className="ri-play-circle-line text-lg"></i>
            {heroData.ctaPrimary}
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full border border-white/25 transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            <i className="ri-information-line text-lg"></i>
            {heroData.ctaSecondary}
          </Link>
        </div>
      </div>
    </section>
  );
}